import DoctorHeader from "assets/doctor-header-home.svg";
import { Headline } from "components/header/Headline";
import React from "react";
import { appPrestadorStoreLink, sendAnalyticEvent } from "utils/store-link";
import { HomeCarouselParceiros } from "./components/carousel/HomeCarouselParceiros";
import { HomeCards } from "./components/HomeCards";
import { HomeStatusSection } from "./components/HomeStatusSection";

export const HomePage = () => {
  const LINK_TO_REGISTER = appPrestadorStoreLink();
  return (
    <div>
      <div className="row d-flex mx-0 bg-primary">
        <div className="col d-none d-md-flex  justify-content-end align-self-center">
          <img
            src={DoctorHeader}
            width="100%"
            height="100%"
            alt=""
            style={{
              alignSelf: "flex-start",
              maxHeight: "350px",
              marginTop: "30px",
            }}
          />
        </div>

        <div className="col pt-3 pb-5">
          <Headline />
          <div className="row justify-content-center justify-content-lg-start">
            <div className="col-12" style={{ maxWidth: "320px" }}>
              <div className="row row-cols-1">
                <div className="col d-flex order-1">
                  <a
                    type="button"
                    className="btn btn-xl btn-header large-button btn-block rounded-pill text-white font-weight-bold my-2 mx-2"
                    href={LINK_TO_REGISTER}
                    onClick={() => sendAnalyticEvent()}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Teste Grátis
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HomeCards />
      <HomeStatusSection />
      <HomeCarouselParceiros />
    </div>
  );
};
